/**
 * If we import main.scss here, remove it from the entry array in ideasonpurpose.config.js
 */

import "../sass/main.scss";

import "../js/modules/menu.js";
import "../js/modules/contact.js";

console.log("JS Loaded");
